import React, { useState, useEffect } from 'react';
import { string } from 'prop-types';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { dynamicRecsDataModel } from '../dataModel';
import { LoadingPlaceholder } from '../core/LoadingPlaceholder';
import DynamicRecs from './DynamicRecs';

const DynamicRecsWrapperComponent = (props) => {
  const { anchor, anchorId } = props;
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (mounted) {
    return (
      /* eslint-disable react/jsx-props-no-spreading */
      <DynamicRecs {...props} anchor={anchor || anchorId} />
    );
  }

  return null;
};

DynamicRecsWrapperComponent.displayName = 'DynamicRecsWrapper';

const propTypes = {
  anchorId: string.isRequired,
  schemaName: string.isRequired,
  anchor: string
};
const defaultProps = {
  anchor: null
};
const dataModel = dynamicRecsDataModel;

DynamicRecsWrapperComponent.propTypes = propTypes;
DynamicRecsWrapperComponent.defaultProps = defaultProps;
DynamicRecsWrapperComponent.dataModel = dataModel;

const HydratedDynamicRecs = withHydrator({
  delay: 1500,
  placeholder: (<LoadingPlaceholder />),
  preserveCtxVal: 'clientStore'
}, DynamicRecsWrapperComponent);

export const DynamicRecsWrapper = withErrorBoundary(HydratedDynamicRecs);

DynamicRecsWrapper.propTypes = propTypes;
DynamicRecsWrapper.defaultProps = defaultProps;
DynamicRecsWrapper.dataModel = dataModel;
DynamicRecsWrapper.displayName = DynamicRecsWrapperComponent.displayName;
